export enum TabEnum {
    SearchBar             = "SearchBar",
    NeighborBatches       = "NeighborBatches",
    BatchInfrastructure   = "BatchInfrastructure",
    ProjectInfrastructure = "ProjectInfrastructure",
    Drawing               = "Drawing",
    Layers                = "Layers",
    Favorite              = "Favorite",
    Print                 = "Print",
    Info                  = "Info",
}

